module.exports = __webpack_public_path__ + "img/esmo.ce6c18e3.png";